export default __webpack_public_path__ + "static/media/budget.7de26fed.svg";